import Nav from "@/components/vu/Nav";
import Footer from "@/components/vu/Footer";

const Section = ({ title, children }) => (
    <div className="mb-9">
        <h2 className="font-display text-[22px] text-[#F5F0E8] mb-3">{title}</h2>
        <div className="text-[15px] leading-[1.75] text-[#A6BDB0] space-y-3">{children}</div>
    </div>
);

export default function PrivacyPolicy() {
    return (
        <main data-testid="privacy-page" className="bg-[#0E1F16] min-h-screen">
            <Nav />
            <div className="max-w-[820px] mx-auto px-8 pt-40 pb-24">
                <h1 className="font-display text-[2.4rem] text-[#F5F0E8] mb-2">Privacy Policy</h1>
                <p className="text-[13px] text-[#7A9088] mb-12">Last updated: [DATE]</p>

                <Section title="1. Who we are">
                    <p>VU Solutions ("we," "us," "our") operates vusolutions-dev.com and provides website design, local SEO, advertising management, email/SMS marketing, and AI voice agent services to businesses ("Clients"). This policy explains what personal data we collect from visitors and Clients, why, and how it's used.</p>
                </Section>

                <Section title="2. Information we collect">
                    <p><b className="text-[#F5F0E8]">Contact form submissions:</b> when you request a consultation, we collect your name, email address, phone number, the service you're interested in, and any message you write.</p>
                    <p><b className="text-[#F5F0E8]">Reviews:</b> if you submit a review on our site, we collect your name, business/role (optional), star rating, and written review. Reviews are published publicly and visible to all site visitors — do not include information in a review you don't want shown publicly.</p>
                    <p><b className="text-[#F5F0E8]">Payment information:</b> if you purchase a plan, payment is processed by Stripe. We do not store your card number ourselves — Stripe handles that directly under its own privacy policy.</p>
                    <p><b className="text-[#F5F0E8]">Analytics:</b> we use Google Analytics (GA4) to understand site traffic and conversions, which may use cookies and similar technologies.</p>
                </Section>

                <Section title="3. How we use your information">
                    <ul className="list-disc pl-5 space-y-1">
                        <li>To respond to your inquiry and follow up about our services</li>
                        <li>To provide services you've purchased, including billing and account management</li>
                        <li>To display reviews you've chosen to submit publicly</li>
                        <li>To improve our website and marketing based on aggregate analytics</li>
                    </ul>
                </Section>

                <Section title="4. Third parties we share data with">
                    <p>We do not sell your personal information. We share data with the following third parties strictly to operate our services:</p>
                    <ul className="list-disc pl-5 space-y-1">
                        <li><b className="text-[#F5F0E8]">Stripe</b> — for payment processing</li>
                        <li><b className="text-[#F5F0E8]">MongoDB Atlas</b> — our database provider, which stores submitted form and review data</li>
                        <li><b className="text-[#F5F0E8]">Orbit Force AI</b> — when you submit the contact form, your name, email, phone number, and inquiry details are forwarded to Orbit Force AI, our AI phone agent partner, so they can contact you by phone regarding your inquiry. By submitting the form, you consent to being contacted by phone, including by an AI voice agent, which may record and transcribe the call for quality and follow-up purposes.</li>
                        <li><b className="text-[#F5F0E8]">Google Analytics</b> — for site traffic analytics</li>
                    </ul>
                </Section>

                <Section title="5. Data retention">
                    <p>We retain inquiry and review data for as long as reasonably necessary to provide our services and comply with legal obligations. You may request deletion of your data at any time (see Section 7).</p>
                </Section>

                <Section title="6. Data security">
                    <p>We use reasonable technical and organizational measures to protect your data, including encrypted connections (HTTPS) and access-controlled databases. No method of transmission or storage is 100% secure, and we cannot guarantee absolute security.</p>
                </Section>

                <Section title="7. Your rights">
                    <p>You may request access to, correction of, or deletion of your personal data, or ask us to stop contacting you, by emailing us at [PRIVACY CONTACT EMAIL]. Depending on your location, you may have additional rights under applicable law (e.g. GDPR, CCPA).</p>
                </Section>

                <Section title="8. Children's privacy">
                    <p>Our services are intended for businesses and individuals 18 years or older. We do not knowingly collect data from children.</p>
                </Section>

                <Section title="9. Changes to this policy">
                    <p>We may update this policy from time to time. Material changes will be reflected by updating the "last updated" date above.</p>
                </Section>

                <Section title="10. Contact us">
                    <p>Questions about this policy? Email us at [PRIVACY CONTACT EMAIL].</p>
                </Section>
            </div>
            <Footer />
        </main>
    );
}